export default __webpack_public_path__ + "704dff6f1b8632cb7f52d3caa439f161.png";